<template>
  <div v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6">
          <div class="vx-col w-full mb-2">
            <router-link
              :to="{ path: '/Pages/Create' }"
              class="vs-component vs-button bg_l_green"
              v-has-permission="permission177"
            >
              <feather-icon
                icon="PlusIcon"
                svgClasses="h-4 w-4"
                class="ico"
              />{{ $t("CreateNewPage") }}
            </router-link>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Title'), sort: 'Title' },
                { title: $t('SubTitle'), sort: 'SubTitle' },
                { title: $t('Priority'), sort: 'Priority' },
                { title: $t('Action') }
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 24%">
                  {{ row.title }}
                </td>
                <td style="width: 24%">
                  {{ row.subTitle }}
                </td>
                <td style="width: 24%">
                  {{ row.priority }}
                </td>
                <td style="width: 24%">
                  <router-link :to="{ path: '/Pages/modify/' + row.id }">
                    <vs-button
                      radius
                      color="success"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="ml-4 d-inline"
                      v-has-permission="permission178"
                    ></vs-button>
                  </router-link>
                  <vs-button
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    @click.prevent="deletePage(row.id)"
                    class="d-inline"
                    v-has-permission="permission179"
                  ></vs-button>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
export default {
  name: "Content_management_Pages_Index",
  components: {
    DataGrid
  },
  data() {
    return {
      permission177: "CreatePage",
      permission178: "ModifyPage",
      permission179: "DeletePage",
      gridDataSource: {
        type: "app",
        service: "CMS/api/PagesQuery"
      },
      gridSearchData: {
        keyword: ""
      }
    };
  },
  methods: {
    ...mapActions({
      removePage: "page/remove"
    }),
    deletePage(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر"
      }).then(result => {
        if (result.value) {
          this.removePage(id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    }
  }
};
</script>
